export enum ReportItem {
  EffectiveDuration = 'edur',
  DV01 = 'dv01',
  Convexity = 'convex',
  YieldToMaturity = 'yld',
  SpreadDuration = 'dts',
  YieldToWorst = 'yldtw',
  CouponRate = 'coup',
  SectorName = 'sectornm',
  CountryName = 'countrynm',
  Currency = 'currency',
  YearsToMaturity = 'yrtomatu',
  DividendYield = 'divdyld',
  AverageLife = 'avglife',
  Beta = 'beta',
  BookToPrice = 'bp',
  BookValue = 'book',
  CashFlowYield = 'yte',
  CurrentYield = 'cyld',
  EPRatio = 'ep',
  EarningsPerShare = 'eps',
  EffectiveD2 = 'ed2',
  EffectiveD3 = 'ed3',
  DurContributionPct = 'durcontp',
  DurContributionYrs = 'portedur',
  EffectiveSpreadDuration = 'spdedur',
  SpreadDurContributionPct = 'sdurconp',
  SpreadDurContributionYrs = 'portsdur',
  GainLoss = 'g_l',
  MacaulayDuration = 'dur',
  MarketCap = 'mcap',
  MarketCapLog = 'lnmcap',
  MarketValue = 'mkval',
  MarketValuePar = 'mkpar',
  MaturityDate = 'matu',
  ModifiedDuration = 'moddur',
  Momentum = 'momentum',
  MoodyQuality = 'moody',
  NotionalValue = 'fmkval',
  OAS = 'espread',
  PBRatio = 'pbr',
  PERatio = 'per',
  PctFaceMarketValue = 'fpmkval',
  PctMarketValue = 'pmkval',
  Price = 'price',
  SPQuality = 'sandp',
  SecurityCount = 'numsec',
  BaseTotalAccruedInterest = 'btotaccr',
  TrailingEPS = 'epsy',
  Volatility = 'volty',
  YearsToWorst = 'yrtow',
  MSCICountry = 'cntymsl',
  GICSIndustryGrp = 'msindgrpl',
  GICSIndustry = 'msindusl',
  GICSSector = 'mssectl',
  GICSSubIndustry = 'mssubindl',
  ReturnOnEquity = 'roe',
  DatedDate = 'datedd',
  KeyRate1Month = 'kdur01mo',
  KeyRate1Year = 'kdur01yr',
  KeyRate2Year = 'kdur02yr',
  KeyRate3Month = 'kdur03mo',
  KeyRate3Year = 'kdur03yr',
  KeyRate4Year = 'kdur04yr',
  KeyRate5Year = 'kdur05yr',
  KeyRate6Month = 'kdur06mo',
  KeyRate6Year = 'kdur06yr',
  KeyRate7Year = 'kdur07yr',
  KeyRate8Year = 'kdur08yr',
  KeyRate9Month = 'kdur09mo',
  KeyRate9Year = 'kdur09yr',
  KeyRate10Year = 'kdur10yr',
  KeyRate15Year = 'kdur15yr',
  KeyRate0Year = 'kdur20yr',
  KeyRate25Year = 'kdur25yr',
  KeyRate30Year = 'kdur30yr',
  AssetType = 'assetnm',
  AssetClass = 'astcls',
  CountryofIncorp = 'cntyincl',
  CountryofRisk = 'cntyriskl',
  CountryCode = 'country',
  BaseCurrencyName = 'currncynm',
  CUSIP9 = 'cusip9',
  ExchangeTicker = 'extk',
  Holdings = 'holdings',
  ISIN12 = 'isin12',
  Description = 'security',
  SEDOL7 = 'sedol7',
  StandardID = 'standid'
  // End ReportItem
}
const ReportItemValues = Object.values(ReportItem);
export function isReportItem(value: string): value is ReportItem {
  return ReportItemValues.includes(value as any)
}

export type ReportTotalItem =
  ReportItem.EffectiveDuration |
  ReportItem.DV01 |
  ReportItem.Convexity |
  ReportItem.YieldToMaturity |
  ReportItem.YearsToMaturity |
  ReportItem.SpreadDuration |
  ReportItem.CouponRate |
  ReportItem.DividendYield |
  ReportItem.AverageLife |
  ReportItem.Beta |
  ReportItem.BookToPrice |
  ReportItem.BookValue |
  ReportItem.CashFlowYield |
  ReportItem.CurrentYield |
  ReportItem.EPRatio |
  ReportItem.EarningsPerShare |
  ReportItem.EffectiveD2 |
  ReportItem.EffectiveD3 |
  ReportItem.DurContributionPct |
  ReportItem.DurContributionYrs |
  ReportItem.EffectiveSpreadDuration |
  ReportItem.SpreadDurContributionPct |
  ReportItem.SpreadDurContributionYrs |
  ReportItem.GainLoss |
  ReportItem.MacaulayDuration |
  ReportItem.MarketCap |
  ReportItem.MarketCapLog |
  ReportItem.MarketValue |
  ReportItem.MarketValuePar |
  ReportItem.ModifiedDuration |
  ReportItem.Momentum |
  ReportItem.MoodyQuality |
  ReportItem.NotionalValue |
  ReportItem.OAS |
  ReportItem.PBRatio |
  ReportItem.PERatio |
  ReportItem.PctFaceMarketValue |
  ReportItem.PctMarketValue |
  ReportItem.Price |
  ReportItem.SPQuality |
  ReportItem.SecurityCount |
  ReportItem.BaseTotalAccruedInterest |
  ReportItem.TrailingEPS |
  ReportItem.Volatility |
  ReportItem.YearsToWorst |
  ReportItem.YieldToWorst;

export const AllReportTotalItems: ReportTotalItem[] = ReportItemValues.filter(i => isTotalItemSubset(i));
export function isTotalItemSubset(item: ReportItem): item is ReportTotalItem {
    switch (item) {
      case ReportItem.EffectiveDuration:
      case ReportItem.DV01:
      case ReportItem.Convexity:
      case ReportItem.YieldToMaturity:
      case ReportItem.YearsToMaturity:
      case ReportItem.SpreadDuration:
      case ReportItem.CouponRate:
      case ReportItem.DividendYield:
      case ReportItem.AverageLife:
      case ReportItem.Beta:
      case ReportItem.BookToPrice:
      case ReportItem.BookValue:
      case ReportItem.CashFlowYield:
      case ReportItem.CurrentYield:
      case ReportItem.EPRatio:
      case ReportItem.EarningsPerShare:
      case ReportItem.EffectiveD2:
      case ReportItem.EffectiveD3:
      case ReportItem.DurContributionPct:
      case ReportItem.DurContributionYrs:
      case ReportItem.EffectiveSpreadDuration:
      case ReportItem.SpreadDurContributionPct:
      case ReportItem.SpreadDurContributionYrs:
      case ReportItem.GainLoss:
      case ReportItem.MacaulayDuration:
      case ReportItem.MarketCap:
      case ReportItem.MarketCapLog:
      case ReportItem.MarketValue:
      case ReportItem.MarketValuePar:
      case ReportItem.ModifiedDuration:
      case ReportItem.Momentum:
      case ReportItem.MoodyQuality:
      case ReportItem.NotionalValue:
      case ReportItem.OAS:
      case ReportItem.PBRatio:
      case ReportItem.PERatio:
      case ReportItem.PctFaceMarketValue:
      case ReportItem.PctMarketValue:
      case ReportItem.Price:
      case ReportItem.SPQuality:
      case ReportItem.SecurityCount:
      case ReportItem.BaseTotalAccruedInterest:
      case ReportItem.TrailingEPS:
      case ReportItem.Volatility:
      case ReportItem.YearsToWorst:
      case ReportItem.YieldToWorst:
        return true;
    }
    return false;
}
export function isReportTotalItem(value: string | ReportItem): value is ReportTotalItem {
  return AllReportTotalItems.some(item => item === value);
}

export type ReportItemDataUnit = "%" | "bp-yr" | "Years" | "Base CCY" | "Local CCY";
export type ReportItemWeightingMethod = "Notional" | "Sum" | "Avg" | "Par";

export type ReportItemMetadata = {
  title: string,
  header: string,
  shortened?: string,
  description: string
  displayFormat?: string
  displayPrecision?: number
  weightingMethod?: string
  isString?: boolean
  isRating?: boolean
}

export const ReportItemDisplayInfoLookup: Record<ReportItem, ReportItemMetadata> = {
  [ReportItem.EffectiveDuration]: {
    title: "Effective Duration",
    header: "Effective Duration (Yrs)",
    shortened: "Eff Dur (yrs)",
    description: "Price sensitivity to yield curve shifts",
    weightingMethod: "Notional",
    displayFormat: "Years",
    displayPrecision: 2,
  },
  [ReportItem.DV01]: {
    title: "Portfolio DV01",
    header: "DV01 (Base CCY)",
    shortened: "DV01 (CCY)",
    description: "Value change per 1bp yield move",
    weightingMethod: "Sum",
    displayFormat: "Base CCY",
    displayPrecision: 2,
  },
  [ReportItem.Convexity]: {
    title: "Convexity",
    header: "Convexity",
    description: "Rate of change of duration vs yield",
    weightingMethod: "Notional",
    displayPrecision: 2,
  },
  [ReportItem.YieldToMaturity]: {
    title: "Yield to Maturity",
    header: "Yield to Maturity (%)",
    shortened: "YTM (%)",
    description: "Total return if held to maturity",
    weightingMethod: "Notional",
    displayFormat: "%",
    displayPrecision: 2,
  },
  [ReportItem.SpreadDuration]: {
    title: "Duration Times Spread",
    header: "Duration Times Spread (bp-yr)",
    shortened: "DTS (bp-yr)",
    description: "Spread duration multiplied by OAS",
    weightingMethod: "Notional",
    displayFormat: "bp-yr",
    displayPrecision: 2,
  },
  [ReportItem.YieldToWorst]: {
    title: "Yield to Worst",
    header: "Yield to Worst (%)",
    shortened: "YTW (%)",
    description: "Lowest yield accounting for call/put options",
    weightingMethod: "Notional",
    displayFormat: "%",
    displayPrecision: 2,
  },
  [ReportItem.CouponRate]: {
    title: "Coupon Rate",
    header: "Coupon Rate (%)",
    shortened: "Coupon (%)",
    description: "Annual interest as % of face value",
    weightingMethod: "Par",
    displayFormat: "%",
    displayPrecision: 2,
  },
  [ReportItem.SectorName]: {
    title: "Sector Description",
    header: "Sector Description",
    description: "",
    isString: true,
  },
  [ReportItem.CountryName]: {
    title: "Country Name",
    header: "Country Name",
    description: "",
    isString: true,
  },
  [ReportItem.Currency]: {
    title: "Base Currency",
    header: "Base Currency Code",
    shortened: "CCY Code",
    description: "",
    isString: true,
  },
  [ReportItem.YearsToMaturity]: {
    title: "Years to Maturity",
    header: "Years to Maturity",
    shortened: "Yrs to Mat",
    description: "Time remaining until bond maturity",
    weightingMethod: "Notional",
    displayFormat: "Years",
    displayPrecision: 2,
  },
  [ReportItem.DividendYield]: {
    title: "Ann. Dividend Yld",
    header: "Annual Dividend Yield (%)",
    shortened: "Div Yld (%)",
    description: "Dividends as % of share price",
    weightingMethod: "Notional",
    displayFormat: "%",
    displayPrecision: 2,
  },
  [ReportItem.AverageLife]: {
    title: "Average Life",
    header: "Average Life (Yrs)",
    shortened: "Avg Life (yrs)",
    description: "Weighted avg time to principal repayment",
    weightingMethod: "Notional",
    displayFormat: "Years",
    displayPrecision: 2,
  },
  [ReportItem.Beta]: {
    title: "Beta",
    header: "Beta",
    description: "Volatility relative to market",
    weightingMethod: "Notional",
    displayPrecision: 2,
  },
  [ReportItem.BookToPrice]: {
    title: "Book/Price",
    header: "Book / Price",
    shortened: "Book/Price",
    description: "Book value to market price ratio",
    weightingMethod: "Notional",
    displayPrecision: 2,
  },
  [ReportItem.BookValue]: {
    title: "Book Val Per Share",
    header: "Book Value / Share (Base CCY)",
    shortened: "Book Val/Sh (CCY)",
    description: "Net asset value per share",
    weightingMethod: "Notional",
    displayFormat: "Base CCY",
    displayPrecision: 2,
  },
  [ReportItem.CashFlowYield]: {
    title: "Cash Flow Yield",
    header: "Cash Flow Yield (%)",
    shortened: "CF Yld (%)",
    description: "Yield based on projected cash flows",
    weightingMethod: "Notional",
    displayFormat: "%",
    displayPrecision: 2,
  },
  [ReportItem.CurrentYield]: {
    title: "Current Yield",
    header: "Current Yield (%)",
    shortened: "Curr Yld (%)",
    description: "Annual income / current market price",
    weightingMethod: "Par",
    displayFormat: "%",
    displayPrecision: 2,
  },
  [ReportItem.EPRatio]: {
    title: "E/P Ratio",
    header: "E/P Ratio",
    shortened: "E/P",
    description: "Earnings divided by price",
    weightingMethod: "Notional",
    displayPrecision: 2,
  },
  [ReportItem.EarningsPerShare]: {
    title: "Earning Per Share",
    header: "Earnings Per Share (Base CCY)",
    shortened: "EPS (CCY)",
    description: "Net income per share outstanding",
    weightingMethod: "Notional",
    displayFormat: "Base CCY",
    displayPrecision: 2,
  },
  [ReportItem.EffectiveD2]: {
    title: "Effective D2",
    header: "Effective D2 (Yrs)",
    shortened: "Eff D2 (yrs)",
    description: "Second-order yield price sensitivity",
    weightingMethod: "Notional",
    displayFormat: "Years",
    displayPrecision: 2,
  },
  [ReportItem.EffectiveD3]: {
    title: "Effective D3",
    header: "Effective D3 (Yrs)",
    shortened: "Eff D3 (yrs)",
    description: "Third-order yield price sensitivity",
    weightingMethod: "Notional",
    displayFormat: "Years",
    displayPrecision: 2,
  },
  [ReportItem.DurContributionPct]: {
    title: "Edur Contribution %",
    header: "Effective Duration Contribution (%)",
    shortened: "EDur Cont (%)",
    description: "Holding's % contribution to portfolio duration",
    weightingMethod: "Sum",
    displayFormat: "%",
    displayPrecision: 2,
  },
  [ReportItem.DurContributionYrs]: {
    title: "Edur Contribution",
    header: "Effective Duration Contribution (Yrs)",
    shortened: "EDur Cont (yrs)",
    description: "Holding's duration contribution in years",
    weightingMethod: "Sum",
    displayFormat: "Years",
    displayPrecision: 2,
  },
  [ReportItem.EffectiveSpreadDuration]: {
    title: "Effective Spread Dur",
    header: "Effective Spread Duration (Yrs)",
    shortened: "Eff Spd Dur (yrs)",
    description: "Price sensitivity to spread changes",
    weightingMethod: "Notional",
    displayFormat: "Years",
    displayPrecision: 2,
  },
  [ReportItem.SpreadDurContributionPct]: {
    title: "Eff Spd Dur Contr %",
    header: "Effective Spread Duration Contribution (%)",
    shortened: "ESpd Dur Cont (%)",
    description: "Holding's % contribution to spread duration",
    weightingMethod: "Sum",
    displayFormat: "%",
    displayPrecision: 2,
  },
  [ReportItem.SpreadDurContributionYrs]: {
    title: "Eff Spread Dur Contr",
    header: "Effective Spread Duration Contribution (Yrs)",
    shortened: "ESpd Dur Cont (yrs)",
    description: "Holding's spread duration contribution in years",
    weightingMethod: "Sum",
    displayFormat: "Years",
    displayPrecision: 2,
  },
  [ReportItem.GainLoss]: {
    title: "Gain/loss",
    header: "Gain / Loss (Base CCY)",
    shortened: "G/L (CCY)",
    description: "Unrealized gain or loss on position",
    weightingMethod: "Sum",
    displayFormat: "Base CCY",
    displayPrecision: 2,
  },
  [ReportItem.MacaulayDuration]: {
    title: "Duration to Maturity",
    header: "Macaulay Duration (Yrs)",
    shortened: "Mac Dur (yrs)",
    description: "Weighted avg time to receive cash flows",
    weightingMethod: "Notional",
    displayFormat: "Years",
    displayPrecision: 2,
  },
  [ReportItem.MarketCap]: {
    title: "Market Cap.",
    header: "Market Capitalization (Base CCY)",
    shortened: "Mkt Cap (CCY)",
    description: "Total market value of outstanding shares",
    weightingMethod: "Notional",
    displayFormat: "Base CCY",
    displayPrecision: 2,
  },
  [ReportItem.MarketCapLog]: {
    title: "Log Market Cap",
    header: "Market Capitalization (Log)",
    shortened: "Mkt Cap (Log)",
    description: "Log of market capitalization",
    weightingMethod: "Sum",
    displayPrecision: 2,
  },
  [ReportItem.MarketValue]: {
    title: "Market Value Held",
    header: "Market Value (Base CCY)",
    shortened: "Mkt Val (CCY)",
    description: "Current market value of position",
    weightingMethod: "Sum",
    displayFormat: "Base CCY",
    displayPrecision: 2,
  },
  [ReportItem.MarketValuePar]: {
    title: "Mkt Val w/o Accrued",
    header: "Market Value w/o Accrued (Base CCY)",
    shortened: "Mkt Val ex-Accr (CCY)",
    description: "Market value relative to par",
    weightingMethod: "Sum",
    displayFormat: "Base CCY",
    displayPrecision: 2,
  },
  [ReportItem.MaturityDate]: {
    title: "Maturity Date",
    header: "Maturity Date",
    description: "",
    isString: true,
  },
  [ReportItem.ModifiedDuration]: {
    title: "Mod Dur to Maturity",
    header: "Modified Duration (Yrs)",
    shortened: "Mod Dur (yrs)",
    description: "Price change % per 1% yield change",
    weightingMethod: "Notional",
    displayFormat: "Years",
    displayPrecision: 2,
  },
  [ReportItem.Momentum]: {
    title: "Momentum",
    header: "Momentum",
    description: "Rate of price change over time",
    weightingMethod: "Notional",
    displayPrecision: 2,
  },
  [ReportItem.MoodyQuality]: {
    title: "Moody's Quality",
    header: "Moody's Quality",
    description: "Moody's credit rating",
    weightingMethod: "Notional",
    isString: true,
    isRating: true,
  },
  [ReportItem.NotionalValue]: {
    title: "Notional Value Held",
    header: "Notional Value Held (Base CCY)",
    shortened: "Notional Val (CCY)",
    description: "Face value of position",
    weightingMethod: "Sum",
    displayFormat: "Base CCY",
    displayPrecision: 2,
  },
  [ReportItem.OAS]: {
    title: "Effective Spread",
    header: "OAS (bps)",
    description: "Option-adjusted spread over risk-free rate",
    weightingMethod: "Notional",
    displayFormat: "bps",
    displayPrecision: 2,
  },
  [ReportItem.PBRatio]: {
    title: "Price/Book",
    header: "P/B Ratio",
    shortened: "P/B",
    description: "Price relative to book value",
    weightingMethod: "Notional",
    displayPrecision: 2,
  },
  [ReportItem.PERatio]: {
    title: "P/E Ratio",
    header: "P/E Ratio",
    shortened: "P/E",
    description: "Price relative to earnings",
    weightingMethod: "Notional",
    displayPrecision: 2,
  },
  [ReportItem.PctFaceMarketValue]: {
    title: "Unadjusted % of Port",
    header: "Percent of Notional Value (%)",
    shortened: "% Notional",
    description: "Position as % of portfolio market value",
    weightingMethod: "Sum",
    displayFormat: "%",
    displayPrecision: 2,
  },
  [ReportItem.PctMarketValue]: {
    title: "Percent Invested",
    header: "Percent of Market Value (%)",
    shortened: "% Invested",
    description: "Position as % of portfolio face value",
    weightingMethod: "Sum",
    displayFormat: "%",
    displayPrecision: 2,
  },
  [ReportItem.Price]: {
    title: "Price",
    header: "Price (Local CCY)",
    shortened: "Price (CCY)",
    description: "Current price in local currency",
    weightingMethod: "Par",
    displayFormat: "Local CCY",
    displayPrecision: 2,
  },
  [ReportItem.SPQuality]: {
    title: "S&P Quality",
    header: "S&P Quality",
    description: "S&P credit rating",
    weightingMethod: "Notional",
    isString: true,
    isRating: true,
  },
  [ReportItem.SecurityCount]: {
    title: "Securities Count",
    header: "Security Count",
    shortened: "Sec Count",
    description: "Number of securities in portfolio",
    weightingMethod: "Sum",
    displayPrecision: 0,
  },
  [ReportItem.BaseTotalAccruedInterest]: {
    title: "Base Total Accrued Int",
    header: "Accrued Interest (Base CCY)",
    shortened: "Accrued Int (CCY)",
    description: "Accrued interest on fixed income positions",
    weightingMethod: "Sum",
    displayFormat: "Base CCY",
    displayPrecision: 2,
  },
  [ReportItem.TrailingEPS]: {
    title: "Latest 12 mo EPS",
    header: "Trailing 12M EPS (Base CCY)",
    shortened: "EPS T12M (CCY)",
    description: "Earnings per share over trailing 12 months",
    weightingMethod: "Notional",
    displayFormat: "Base CCY",
    displayPrecision: 2,
  },
  [ReportItem.Volatility]: {
    title: "Volatility",
    header: "Volatility",
    description: "Historical price volatility",
    weightingMethod: "Notional",
    displayPrecision: 2,
  },
  [ReportItem.YearsToWorst]: {
    title: "Years to Worst",
    header: "Years to Worst",
    shortened: "Yrs to Worst",
    description: "Time until earliest worst-case redemption",
    weightingMethod: "Notional",
    displayFormat: "Years",
    displayPrecision: 2,
  },
  [ReportItem.MSCICountry]: {
    title: "MSCI Country (L)",
    header: "MSCI Country",
    description: "",
    isString: true,
  },
  [ReportItem.GICSIndustryGrp]: {
    title: "GICS Industry Grp(L)",
    header: "GICS Industry Group",
    shortened: "GICS Ind Grp",
    description: "",
    isString: true,
  },
  [ReportItem.GICSIndustry]: {
    title: "GICS Industry (L)",
    header: "GICS Industry",
    description: "",
    isString: true,
  },
  [ReportItem.GICSSector]: {
    title: "GICS Sector (L)",
    header: "GICS Sector",
    description: "",
    isString: true,
  },
  [ReportItem.GICSSubIndustry]: {
    title: "GICS-Sub Industry",
    header: "GICS Sub-Industry",
    shortened: "GICS Sub-Ind",
    description: "",
    isString: true,
  },
  [ReportItem.ReturnOnEquity]: {
    title: "Return on Equity",
    header: "Return on Equity (%)",
    shortened: "ROE (%)",
    description: "",
    displayFormat: "%",
    isString: true,
  },
  [ReportItem.DatedDate]: {
    title: "Dated Date",
    header: "Dated Date",
    description: "",
    isString: true,
  },
  [ReportItem.KeyRate1Month]: {
    title: "K1M - 1 Month",
    header: "KR 1M (yrs)",
    description: "",
    weightingMethod: "Notional",
    displayFormat: "Years",
    displayPrecision: 2,
  },
  [ReportItem.KeyRate1Year]: {
    title: "K01 - 1 Year",
    header: "KR 1Y (yrs)",
    description: "",
    weightingMethod: "Notional",
    displayFormat: "Years",
    displayPrecision: 2,
  },
  [ReportItem.KeyRate2Year]: {
    title: "K02 - 2 Year",
    header: "KR 2Y (yrs)",
    description: "",
    weightingMethod: "Notional",
    displayFormat: "Years",
    displayPrecision: 2,
  },
  [ReportItem.KeyRate3Month]: {
    title: "K3M - 3 Month",
    header: "KR 3M (yrs)",
    description: "",
    weightingMethod: "Notional",
    displayFormat: "Years",
    displayPrecision: 2,
  },
  [ReportItem.KeyRate3Year]: {
    title: "K03 - 3 Year",
    header: "KR 3Y (yrs)",
    description: "",
    weightingMethod: "Notional",
    displayFormat: "Years",
    displayPrecision: 2,
  },
  [ReportItem.KeyRate4Year]: {
    title: "K04 - 4 Year",
    header: "KR 4Y (yrs)",
    description: "",
    weightingMethod: "Notional",
    displayFormat: "Years",
    displayPrecision: 2,
  },
  [ReportItem.KeyRate5Year]: {
    title: "K05 - 5 Year",
    header: "KR 5Y (yrs)",
    description: "",
    weightingMethod: "Notional",
    displayFormat: "Years",
    displayPrecision: 2,
  },
  [ReportItem.KeyRate6Month]: {
    title: "K6M - 6 Month",
    header: "KR 6M (yrs)",
    description: "",
    weightingMethod: "Notional",
    displayFormat: "Years",
    displayPrecision: 2,
  },
  [ReportItem.KeyRate6Year]: {
    title: "K06 - 6 Year",
    header: "KR 6Y (yrs)",
    description: "",
    weightingMethod: "Notional",
    displayFormat: "Years",
    displayPrecision: 2,
  },
  [ReportItem.KeyRate7Year]: {
    title: "K07 - 7 Year",
    header: "KR 7Y (yrs)",
    description: "",
    weightingMethod: "Notional",
    displayFormat: "Years",
    displayPrecision: 2,
  },
  [ReportItem.KeyRate8Year]: {
    title: "K08 - 8 Year",
    header: "KR 8Y (yrs)",
    description: "",
    weightingMethod: "Notional",
    displayFormat: "Years",
    displayPrecision: 2,
  },
  [ReportItem.KeyRate9Month]: {
    title: "K9M - 9 Month",
    header: "KR 9M (yrs)",
    description: "",
    weightingMethod: "Notional",
    displayFormat: "Years",
    displayPrecision: 2,
  },
  [ReportItem.KeyRate9Year]: {
    title: "K09 - 9 Year",
    header: "KR 9Y (yrs)",
    description: "",
    weightingMethod: "Notional",
    displayFormat: "Years",
    displayPrecision: 2,
  },
  [ReportItem.KeyRate10Year]: {
    title: "K10 - 10 Year",
    header: "KR 10Y (yrs)",
    description: "",
    weightingMethod: "Notional",
    displayFormat: "Years",
    displayPrecision: 2,
  },
  [ReportItem.KeyRate15Year]: {
    title: "K15 - 15 Year",
    header: "KR 15Y (yrs)",
    description: "",
    weightingMethod: "Notional",
    displayFormat: "Years",
    displayPrecision: 2,
  },
  [ReportItem.KeyRate0Year]: {
    title: "K20 - 20 Year",
    header: "KR 20Y (yrs)",
    description: "",
    weightingMethod: "Notional",
    displayFormat: "Years",
    displayPrecision: 2,
  },
  [ReportItem.KeyRate25Year]: {
    title: "K25 - 25 Year",
    header: "KR 25Y (yrs)",
    description: "",
    weightingMethod: "Notional",
    displayFormat: "Years",
    displayPrecision: 2,
  },
  [ReportItem.KeyRate30Year]: {
    title: "K30 - 30 Year",
    header: "KR 30Y (yrs)",
    description: "",
    weightingMethod: "Notional",
    displayFormat: "Years",
    displayPrecision: 2,
  },
  [ReportItem.AssetType]: {
    title: "Asset Type",
    header: "Asset Type",
    description: "",
    isString: true,
  },
  [ReportItem.AssetClass]: {
    title: "Asset Class",
    header: "Asset Class",
    description: "",
    isString: true,
  },
  [ReportItem.CountryofIncorp]: {
    title: "Country of Incorp(L)",
    header: "Country of Incorporation",
    shortened: "Country Incorp",
    description: "",
    isString: true,
  },
  [ReportItem.CountryofRisk]: {
    title: "Country of Risk (L)",
    header: "Country of Risk",
    description: "",
    isString: true,
  },
  [ReportItem.CountryCode]: {
    title: "Country Code",
    header: "Country Code",
    description: "",
    isString: true,
  },
  [ReportItem.BaseCurrencyName]: {
    title: "Base Currency Name",
    header: "Base Currency Name",
    shortened: "CCY Name",
    description: "",
    isString: true,
  },
  [ReportItem.CUSIP9]: {
    title: "CUSIP(9)",
    header: "CUSIP",
    description: "",
    isString: true,
  },
  [ReportItem.ExchangeTicker]: {
    title: "Exchange Ticker",
    header: "Exchange Ticker",
    shortened: "Ticker",
    description: "",
    isString: true,
  },
  [ReportItem.Holdings]: {
    title: "Holdings",
    header: "Holdings",
    description: "",
    isString: true,
  },
  [ReportItem.ISIN12]: {
    title: "ISIN12",
    header: "ISIN",
    description: "",
    isString: true,
  },
  [ReportItem.Description]: {
    title: "Description",
    header: "Description",
    description: "",
    isString: true,
  },
  [ReportItem.SEDOL7]: {
    title: "SEDOL (7)",
    header: "SEDOL",
    description: "",
    isString: true,
  },
  [ReportItem.StandardID]: {
    title: "Standard ID",
    header: "Identifier",
    description: "",
    isString: true,
  }
}

export function getReportItemMetadata(item: ReportItem) {
  return ReportItemDisplayInfoLookup[item];
}
